import React from 'react';
import clsx from 'clsx';

import './TooltipIcon.css';
import { noop } from 'util/function';
import MaterialIcon, { MaterialIconProps } from 'components/icon/MaterialIcon';
import Tooltip, { TooltipProps } from 'components/tooltip/Tooltip';

//
// --- Types ---

interface TooltipIconProps extends Omit<TooltipProps, 'children'> {
  iconClassName?: string;
  iconColor?: MaterialIconProps['color'];
  iconName: MaterialIconProps['name'];
  iconTestId?: string;
  onIconClick?: MaterialIconProps['onClick'];
  tooltipClassName?: string;
}

//
// --- TooltipIcon Component ---

const TooltipIcon: React.FC<TooltipIconProps> = props => {
  const { iconClassName, iconColor, iconName, iconTestId, onIconClick, tooltipClassName, ...remainingTooltipProps } =
    props;

  return (
    <Tooltip classes={{ tooltip: clsx('tooltip-icon-tooltip', tooltipClassName) }} {...remainingTooltipProps}>
      <MaterialIcon
        className={clsx(
          'tooltip-icon',
          { 'tooltip-icon-clickable': typeof onIconClick === 'function' && onIconClick !== noop },
          iconClassName
        )}
        color={iconColor}
        data-testid={iconTestId || 'tooltip-icon'}
        name={iconName}
        onClick={onIconClick}
      />
    </Tooltip>
  );
};

export default TooltipIcon;
